"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query GetUsersAndTeams($organisationId: String!) {\n    bdms: getUsers(organisationId: $organisationId, role: \"SHOOTSTA_BDM\") {\n        userId\n        firstName\n        lastName\n        imageUrl\n        officeLocation\n        department\n    },\n    accountManagers: getUsers(organisationId: $organisationId, role: \"SHOOTSTA_AM\") {\n        userId\n        firstName\n        lastName\n        imageUrl\n        officeLocation\n        department\n    },\n    getTeams(organisationId: $organisationId) {\n        teamId\n        name\n        imageUrl\n        branch\n        membersCount\n        type\n        membersPreview {\n          firstName\n          lastName\n          officeLocation\n          department\n          imageUrl\n        }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var usersAndTeamsQuery = (0, _graphqlTag.default)(_templateObject());

var getUsersAndTeams = function getUsersAndTeams(organisationId) {
  return {
    query: usersAndTeamsQuery,
    module: 'users',
    ignoreCache: true,
    buildVariables: function buildVariables() {
      return {
        organisationId: organisationId
      };
    }
  };
};

var _default = getUsersAndTeams;
exports.default = _default;